/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetClientDto } from './GetClientDto';
import {
    GetClientDtoFromJSON,
    GetClientDtoFromJSONTyped,
    GetClientDtoToJSON,
} from './GetClientDto';
import type { GetCurrencyDto } from './GetCurrencyDto';
import {
    GetCurrencyDtoFromJSON,
    GetCurrencyDtoFromJSONTyped,
    GetCurrencyDtoToJSON,
} from './GetCurrencyDto';

/**
 * 
 * @export
 * @interface GetNumberingDtoCompany
 */
export interface GetNumberingDtoCompany {
    /**
     * 
     * @type {string}
     * @memberof GetNumberingDtoCompany
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetNumberingDtoCompany
     */
    systemNumber: number;
    /**
     * 
     * @type {string}
     * @memberof GetNumberingDtoCompany
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetNumberingDtoCompany
     */
    shortname: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetNumberingDtoCompany
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetNumberingDtoCompany
     */
    personalLanguage: GetNumberingDtoCompanyPersonalLanguageEnum;
    /**
     * 
     * @type {string}
     * @memberof GetNumberingDtoCompany
     */
    color: string;
    /**
     * 
     * @type {string}
     * @memberof GetNumberingDtoCompany
     */
    logo: string;
    /**
     * 
     * @type {string}
     * @memberof GetNumberingDtoCompany
     */
    stamp: string;
    /**
     * 
     * @type {number}
     * @memberof GetNumberingDtoCompany
     */
    projectMaxDaysDelay: number;
    /**
     * 
     * @type {number}
     * @memberof GetNumberingDtoCompany
     */
    orderField: number;
    /**
     * 
     * @type {GetClientDto}
     * @memberof GetNumberingDtoCompany
     */
    client: GetClientDto;
    /**
     * 
     * @type {string}
     * @memberof GetNumberingDtoCompany
     */
    invoicesEmail: string;
    /**
     * 
     * @type {string}
     * @memberof GetNumberingDtoCompany
     */
    footer: string;
    /**
     * 
     * @type {string}
     * @memberof GetNumberingDtoCompany
     */
    footerInEnglish: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetNumberingDtoCompany
     */
    showMargin: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetNumberingDtoCompany
     */
    templateType: GetNumberingDtoCompanyTemplateTypeEnum;
    /**
     * 
     * @type {GetCurrencyDto}
     * @memberof GetNumberingDtoCompany
     */
    mainCurrency: GetCurrencyDto;
    /**
     * 
     * @type {string}
     * @memberof GetNumberingDtoCompany
     */
    language: GetNumberingDtoCompanyLanguageEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetNumberingDtoCompany
     */
    eod: boolean;
    /**
     * 
     * @type {Date}
     * @memberof GetNumberingDtoCompany
     */
    ksef?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof GetNumberingDtoCompany
     */
    symphonyHandel?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetNumberingDtoCompany
     */
    pathPhase: boolean;
}


/**
 * @export
 */
export const GetNumberingDtoCompanyPersonalLanguageEnum = {
    Projects: 'Projects',
    Campaigns: 'Campaigns'
} as const;
export type GetNumberingDtoCompanyPersonalLanguageEnum = typeof GetNumberingDtoCompanyPersonalLanguageEnum[keyof typeof GetNumberingDtoCompanyPersonalLanguageEnum];

/**
 * @export
 */
export const GetNumberingDtoCompanyTemplateTypeEnum = {
    Poland: 'Poland',
    UnitedStates: 'UnitedStates',
    Germany: 'Germany'
} as const;
export type GetNumberingDtoCompanyTemplateTypeEnum = typeof GetNumberingDtoCompanyTemplateTypeEnum[keyof typeof GetNumberingDtoCompanyTemplateTypeEnum];

/**
 * @export
 */
export const GetNumberingDtoCompanyLanguageEnum = {
    Pl: 'PL',
    En: 'EN'
} as const;
export type GetNumberingDtoCompanyLanguageEnum = typeof GetNumberingDtoCompanyLanguageEnum[keyof typeof GetNumberingDtoCompanyLanguageEnum];


/**
 * Check if a given object implements the GetNumberingDtoCompany interface.
 */
export function instanceOfGetNumberingDtoCompany(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "systemNumber" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "shortname" in value;
    isInstance = isInstance && "active" in value;
    isInstance = isInstance && "personalLanguage" in value;
    isInstance = isInstance && "color" in value;
    isInstance = isInstance && "logo" in value;
    isInstance = isInstance && "stamp" in value;
    isInstance = isInstance && "projectMaxDaysDelay" in value;
    isInstance = isInstance && "orderField" in value;
    isInstance = isInstance && "client" in value;
    isInstance = isInstance && "invoicesEmail" in value;
    isInstance = isInstance && "footer" in value;
    isInstance = isInstance && "footerInEnglish" in value;
    isInstance = isInstance && "showMargin" in value;
    isInstance = isInstance && "templateType" in value;
    isInstance = isInstance && "mainCurrency" in value;
    isInstance = isInstance && "language" in value;
    isInstance = isInstance && "eod" in value;
    isInstance = isInstance && "pathPhase" in value;

    return isInstance;
}

export function GetNumberingDtoCompanyFromJSON(json: any): GetNumberingDtoCompany {
    return GetNumberingDtoCompanyFromJSONTyped(json, false);
}

export function GetNumberingDtoCompanyFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetNumberingDtoCompany {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'systemNumber': json['systemNumber'],
        'name': json['name'],
        'shortname': json['shortname'],
        'active': json['active'],
        'personalLanguage': json['personalLanguage'],
        'color': json['color'],
        'logo': json['logo'],
        'stamp': json['stamp'],
        'projectMaxDaysDelay': json['projectMaxDaysDelay'],
        'orderField': json['orderField'],
        'client': GetClientDtoFromJSON(json['client']),
        'invoicesEmail': json['invoicesEmail'],
        'footer': json['footer'],
        'footerInEnglish': json['footerInEnglish'],
        'showMargin': json['showMargin'],
        'templateType': json['templateType'],
        'mainCurrency': GetCurrencyDtoFromJSON(json['mainCurrency']),
        'language': json['language'],
        'eod': json['eod'],
        'ksef': !exists(json, 'ksef') ? undefined : (new Date(json['ksef'])),
        'symphonyHandel': !exists(json, 'symphonyHandel') ? undefined : json['symphonyHandel'],
        'pathPhase': json['pathPhase'],
    };
}

export function GetNumberingDtoCompanyToJSON(value?: GetNumberingDtoCompany | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'systemNumber': value.systemNumber,
        'name': value.name,
        'shortname': value.shortname,
        'active': value.active,
        'personalLanguage': value.personalLanguage,
        'color': value.color,
        'logo': value.logo,
        'stamp': value.stamp,
        'projectMaxDaysDelay': value.projectMaxDaysDelay,
        'orderField': value.orderField,
        'client': GetClientDtoToJSON(value.client),
        'invoicesEmail': value.invoicesEmail,
        'footer': value.footer,
        'footerInEnglish': value.footerInEnglish,
        'showMargin': value.showMargin,
        'templateType': value.templateType,
        'mainCurrency': GetCurrencyDtoToJSON(value.mainCurrency),
        'language': value.language,
        'eod': value.eod,
        'ksef': value.ksef === undefined ? undefined : (value.ksef.toISOString()),
        'symphonyHandel': value.symphonyHandel,
        'pathPhase': value.pathPhase,
    };
}

